const moment = window.moment;

// Strips slashes from a numeric id
export default function () {
  return moment().tz(window.config.timezone).format("X");
}
